module.exports = __webpack_public_path__ + "img/BeanLoading2.4579e6b0.gif";